export const validation = {
  headingMaxChar: 120,
  paragraphMaxChar: 800,
  title: { required: true }
}
